import React from "react";
import { TrendingDown, TrendingUp } from "lucide-react";
import { inr } from "@/lib/api";
import {
  comparisonText,
  STATUS_LABELS,
  STATUS_STYLES,
} from "./dashboardUtils";

export const StatusBadge = ({ status }) => (
  <span
    className={`inline-flex border px-2 py-1 text-[10px] font-semibold uppercase tracking-wide ${
      STATUS_STYLES[status] || "border-[#E2DCD2] bg-[#F4F1EA] text-[#4B5563]"
    }`}
    data-testid={`dashboard-status-badge-${status}`}
  >
    {STATUS_LABELS[status] || status}
  </span>
);

export const MetricCard = ({ metric, previous, comparisonAvailable, onClick }) => {
  const value = metric.currency
    ? inr(metric.value)
    : Number(metric.value || 0).toLocaleString("en-IN");
  const comparison = comparisonText(
    metric.value,
    previous,
    comparisonAvailable,
    metric.currency,
    inr,
  );
  const positive = !comparison.startsWith("-") && comparison !== "No comparison data";
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "group min-h-36 border border-[#E2DCD2] bg-white p-5 text-left shadow-sm",
        "transition-transform duration-150 hover:-translate-y-0.5 hover:border-[#B9CABB]",
        "active:scale-[0.98]",
      ].join(" ")}
      data-testid={`kpi-card-${metric.key.replace(/_/g, "-")}`}
    >
      <div className="text-xs font-semibold uppercase tracking-wider text-[#64748B]">
        {metric.label}
      </div>
      <div className="mt-4 font-mono text-2xl font-extrabold text-[#1E2A24] sm:text-3xl">
        {value}
      </div>
      <div
        className={`mt-3 flex items-center gap-1 text-xs ${
          positive ? "text-[#2D5A47]" : "text-[#64748B]"
        }`}
      >
        {comparison !== "No comparison data" && (
          positive ? <TrendingUp size={13} /> : <TrendingDown size={13} />
        )}
        <span>{comparison}</span>
      </div>
    </button>
  );
};

export const DetailList = ({ items, emptyText, renderItem, testId }) => (
  <div className="divide-y divide-[#EDE8DF]" data-testid={testId}>
    {items.length ? items.map(renderItem) : (
      <div className="py-8 text-center text-sm text-[#64748B]">{emptyText}</div>
    )}
  </div>
);